export default __webpack_public_path__ + "static/media/clear-day.54288da6.svg";